module.exports = __webpack_public_path__ + "img/pipeline.50393d0a.webp";